export const authConfig = {
  apiClientId: process.env.REACT_APP_API_CLIENT_ID?.trim() ?? '',
  apiClientSecret: process.env.REACT_APP_API_CLIENT_SECRET?.trim() ?? '',
  apiUrl: process.env.REACT_APP_API_URL || 'https://localhost:7180/api',
  tokenExpiry: 8 * 60 * 60 * 1000,
  refreshThreshold: 5 * 60 * 1000,
};

export function usesEnvApiCredentials(): boolean {
  return !!authConfig.apiClientId && !!authConfig.apiClientSecret;
}
